var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('IonNavVue',{ref:"nav",on:{"ionNavWillLoad":_vm.onNavWillLoad,"ionNavDidChange":_vm.onNavDidChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }